var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Pack Complete Step
 */
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CheckCircleOutlined } from '@ant-design/icons';
import Button from '@fp-suite/core-ui/src/components/Button';
import Table from '@fp-suite/core-ui/src/components/Table';
import { usePackingState, useShipmentData } from '../../../hooks/packing';
import { selectAssemblyProducts } from '../../../redux/packing';
export var PackCompleteStep = function (_a) {
    var onPackComplete = _a.onPackComplete, onPackMore = _a.onPackMore;
    var t = useTranslation().t;
    var _b = usePackingState(), kitComponentProducts = _b.kitComponentProducts, shipmentId = _b.shipmentId, loadShippingMethods = _b.loadShippingMethods;
    var getTotalItemsCount = useShipmentData().getTotalItemsCount;
    var assemblyProducts = useSelector(selectAssemblyProducts);
    var _c = getTotalItemsCount(), total = _c.total, packed = _c.packed;
    var handlePackComplete = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadShippingMethods(shipmentId)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    onPackComplete();
                    return [2 /*return*/];
            }
        });
    }); }, [shipmentId, loadShippingMethods, onPackComplete]);
    var assemblyTask = useMemo(function () {
        return assemblyProducts === null || assemblyProducts === void 0 ? void 0 : assemblyProducts.reduce(function (acc, cur) {
            acc.estimatedQuantity += cur.estimatedQuantity || 0;
            acc.completed += cur.completed || 0;
            return acc;
        }, { estimatedQuantity: 0, completed: 0 });
    }, [assemblyProducts]);
    var kitProductAssemblyItem = [
        {
            title: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Product') }), void 0),
            render: function (productId, data) { return (_jsxs("span", __assign({ className: 'font-medium text-sm' }, { children: [productId, ": ", data === null || data === void 0 ? void 0 : data.productName] }), void 0)); },
            dataIndex: 'productId'
        },
        {
            title: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Total') }), void 0),
            render: function (quantity) { return _jsx("span", __assign({ className: 'font-medium text-sm' }, { children: quantity }), void 0); },
            dataIndex: 'estimatedQuantity'
        },
        {
            title: _jsx("p", __assign({ className: 'mr-1' }, { children: t('Completed') }), void 0),
            render: function (complete, data) { return (_jsx("span", __assign({ className: "font-bold " + (complete === (data === null || data === void 0 ? void 0 : data.estimatedQuantity) ? 'text-green-500' : 'text-red-500') }, { children: complete }), void 0)); },
            dataIndex: 'completed'
        }
    ];
    return (_jsxs("div", __assign({ className: 'flex flex-col items-center gap-8 py-10' }, { children: [_jsxs("div", __assign({ className: 'text-center' }, { children: [_jsx("div", __assign({ className: 'inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-50 mb-5' }, { children: _jsx(CheckCircleOutlined, { className: 'text-green-500', style: { fontSize: 56 } }, void 0) }), void 0), _jsx("h2", __assign({ className: 'text-xl font-bold' }, { children: t('All Items Packed') }), void 0), _jsxs("p", __assign({ className: 'text-lg text-gray-500 mt-2 font-medium' }, { children: [_jsx("span", __assign({ className: '' }, { children: packed }), void 0), "/", total, " ", t('Packed')] }), void 0)] }), void 0), (kitComponentProducts === null || kitComponentProducts === void 0 ? void 0 : kitComponentProducts.some(function (item) { return (item === null || item === void 0 ? void 0 : item.quantityTotal) > 0; })) && (_jsxs("div", __assign({ className: 'w-full max-w-lg bg-white rounded-xl border border-blue-100 shadow-sm p-4' }, { children: [_jsx("h3", __assign({ className: "font-bold mb-3 " + ((assemblyTask === null || assemblyTask === void 0 ? void 0 : assemblyTask.estimatedQuantity) === (assemblyTask === null || assemblyTask === void 0 ? void 0 : assemblyTask.completed)
                            ? 'text-green-600'
                            : 'text-red-500') }, { children: t('Assembly Task') }), void 0), _jsx(Table, { columns: kitProductAssemblyItem, dataSource: assemblyProducts, isPaginated: false }, 'kitProduct')] }), void 0)), _jsxs("div", __assign({ className: 'flex gap-4' }, { children: [_jsx(Button, { buttonText: t('Pack Complete'), paddingX: 'px-8', paddingY: 'py-3.5', onClick: handlePackComplete, defaultColor: 'bg-green-600', classNames: 'rounded-xl text-base font-semibold' }, void 0), _jsx(Button, { buttonText: t('Pack More Items'), paddingX: 'px-8', paddingY: 'py-3.5', onClick: onPackMore, defaultColor: 'bg-primary', classNames: 'rounded-xl text-base font-semibold' }, void 0)] }), void 0)] }), void 0));
};
export default PackCompleteStep;
